import { GMOUDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as GmouActions from './gmou.actions';

export const GMOU_FEATURE_KEY = 'gmou';

export interface GmouState extends EntityState<GMOUDto> {
  selectedGmouId?: string | number; // which Gmou record has been selected
  loaded: boolean; // has the Gmou list been loaded
  error?: string | null; // last none error (if any)
}

export interface GmouPartialState {
  readonly [GMOU_FEATURE_KEY]: GmouState;
}

export const gmouAdapter: EntityAdapter<GMOUDto> = createEntityAdapter<GMOUDto>(
  {
    selectId: (gmou) => gmou.id,
    sortComparer: false,
  }
);

export const initialState: GmouState = gmouAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedGmouId: null,
});

const gmouReducer = createReducer(
  initialState,
  on(GmouActions.loadGmou, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GmouActions.loadGmouSuccess, (state, { gmou }) =>
    gmouAdapter.addAll(gmou, {
      ...state,
      loaded: false,
    })
  ),
  on(GmouActions.loadGmouFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(GmouActions.addGmou, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GmouActions.addGmouSuccess, (state, { newGmou }) =>
    gmouAdapter.addOne(newGmou, {
      ...state,
      loaded: false,
    })
  ),
  on(GmouActions.addGmouFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(GmouActions.updateGmou, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GmouActions.updateGmouSuccess, (state, { updateGmou }) =>
    gmouAdapter.upsertOne(updateGmou, {
      ...state,
      loaded: false,
    })
  ),
  on(GmouActions.updateGmouFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  // search student

  on(GmouActions.searchGmouRecord, (state, { query }) => {
    return {
      ...state,
      selectedGmouId: query,
      loaded: false,
      error: null,
    };
  }),
  on(GmouActions.removeGmou, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(GmouActions.removeGmouSuccess, (state, { ids }) =>
    gmouAdapter.removeOne(ids, { ...state, loaded: false })
  ),
  on(GmouActions.removeGmouFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: GmouState | undefined, action: Action) {
  return gmouReducer(state, action);
}
